<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm v-on:submit.prevent="login">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <CInput
                    placeholder="Username"
                    autocomplete="username"
                    v-model="auth.username"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    v-model="auth.password"
                    autocomplete="curent-password"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton type="submit" color="primary" class="px-4" :disabled="loading"
                        ><CSpinner size="sm" v-show="loading"/> Login</CButton
                      >
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { HTTPAUTH } from "../../lib/httplib";
import { getErrorMessage, setCookie } from "../../lib/helpers";
export default {
  name: "Login",
  data() {
    return {
      auth: {},
      loading: false,
    };
  },
  methods: {
    login() {
      this.loading = true
      HTTPAUTH.post("/api/admin/user/login", this.auth)
        .then((res) => {
          this.$toasted.success("Berhasil login").goAway();
          setCookie(res.data);
          this.loading = false
          location.href = "/";
        })
        .catch((eres) => {
          this.loading = false
          this.$toasted.error(getErrorMessage(eres)).goAway();
        });
    },
  },
};
</script>